<template>
  <section>
    <div class="row">
      <div ref="messages" class="col-lg-6 offset-lg-3 col-12 container-chat-booking chat-messages">
        <div class="pt-3 px-4">
          <h3>หมวดหมู่บทความ</h3>
        </div>
        <div class="row" v-if="articleCategory.categories.length > 0">
          <div class="col-6 col-md-4" v-for="(category, index) in articleCategory.categories">
            <router-link class="no-style" :to="'/article/category/' + category.slug">
              <div class="card d-flex shadow-sm" style="min-height: 140px;">
                <div class="text-pink text-right pt-2 px-3">
                  {{ category.has_new_articles ? 'New' : '&nbsp;' }}
                </div>
                <div class="card-body py-0 px-1 align-items-center justify-content-center text-center">
                  <div v-if="category.icon">
                    <i :class="category.icon"
                       class="fa-2x text-info"></i>
                  </div>
                  <div class="card-title mb-0 mt-3 text-dark">{{ category.name }}</div>
                </div>
              </div>
            </router-link>
          </div>
        </div>
        <div v-else>
          <loader/>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import { mapState } from 'vuex'
  import axios from 'axios'
  import moment from 'moment-timezone'
  import Loader from '../loader/Loader'

  export default {
    components: {
      Loader
    },
    data () {
      return {
        articles: []
      }
    },
    computed: {
      ...mapState('article', ['articleCategory'])
    },
    watch: {
      'articleCategory.categories': function (newVal, oldVal) {
        this.fetchArticles()
      }
    },
    methods: {
      async fetchArticles () {
        let url = `https://blog.beneat.co/feed/json?paged=1`
        let { data } = await axios.get(url, {
          transformRequest: [(data, headers) => {
            delete headers.Authorization
            return data
          }]
        })
        if (data) {
          this.articles = data
          if (data.items && data.items.length > 0) {
            this.$store.commit('article/CLEAR_HAS_NEW_ARTICLES')
            for (let key in data.items) {
              const item = data.items[key]
              const tagName = item.tags ? item.tags[0] : ''
              const publishedDate = item.date_published
              this.checkNewArticleStatus(tagName, publishedDate)
            }
          }
        }
      },
      checkNewArticleStatus (tagName, publishedDate) {
        const now = moment(new Date()) // todays date
        const end = moment(publishedDate) // another date
        const duration = moment.duration(now.diff(end))
        const diffDays = Math.round(duration.asDays())

        if (diffDays <= 5) {
          const categories = this.articleCategory.categories
          for (let key in categories) {
            const category = categories[key]
            if (category.name === tagName) {
              const data = {
                key: Number(key),
                value: true
              }
              this.$store.commit('article/UPDATE_HAS_NEW_ARTICLES', data)
            }
          }
        }
      },
      toTimestamp (strDate) {
        var datum = Date.parse(strDate)
        return datum / 1000
      }
    },
    mounted () {
      const currentTime = new Date().getTime()
      if (this.articleCategory.categories.length === 0 ||
        (this.articleCategory.categories.length > 0 && currentTime > this.articleCategory.expireDate)) {
        this.$store.dispatch('article/LOAD_ARTICLE_CATEGORY')
      }
      this.$store.dispatch('article/LOAD_ARTICLE_CATEGORY')
      this.fetchArticles()
    }
  }
</script>

<style scoped>
  .card-title {
    font-size: 105%;
    font-weight: 400;
  }
</style>



// WEBPACK FOOTER //
// src/components/article/Category.vue